// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"b20850e6","453":"f2c600f9"}[chunkId] + ".chunk.js";
};